'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('favouritesCtrl', [
    '$rootScope',
    '$scope',
    'ModalService',
    'BAS_HTML',
    'MEDIA_STATES',
    'BAS_SOURCES',
    'BAS_SOURCE',
    'BAS_ROOM',
    'BAS_MODAL',
    'BAS_INPUT_MODAL',
    'BAS_FAVOURITE',
    'BAS_ERRORS',
    'CurrentBasCore',
    'CurrentRoom',
    'Sources',
    'LibraryState',
    'BasModal',
    'BasInputModal',
    'BasFavouritesHelper',
    'BasMediaStateHelper',
    'BasState',
    'BasImageUtil',
    favouritesCtrl
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param ModalService
 * @param {BAS_HTML} BAS_HTML
 * @param {MEDIA_STATES} MEDIA_STATES
 * @param BAS_SOURCES
 * @param BAS_SOURCE
 * @param BAS_ROOM
 * @param {BAS_MODAL} BAS_MODAL
 * @param {BAS_INPUT_MODAL} BAS_INPUT_MODAL
 * @param {BAS_FAVOURITE} BAS_FAVOURITE
 * @param {BAS_ERRORS} BAS_ERRORS
 * @param {CurrentBasCore} CurrentBasCore
 * @param {CurrentRoom} CurrentRoom
 * @param {Sources} Sources
 * @param {LibraryState} LibraryState
 * @param {BasModal} BasModal
 * @param {BasInputModal} BasInputModal
 * @param {BasFavouritesHelper} BasFavouritesHelper
 * @param {BasMediaStateHelper} BasMediaStateHelper
 * @param {BasState} BasState
 * @param {BasImageUtil} BasImageUtil
 */
function favouritesCtrl (
  $rootScope,
  $scope,
  ModalService,
  BAS_HTML,
  MEDIA_STATES,
  BAS_SOURCES,
  BAS_SOURCE,
  BAS_ROOM,
  BAS_MODAL,
  BAS_INPUT_MODAL,
  BAS_FAVOURITE,
  BAS_ERRORS,
  CurrentBasCore,
  CurrentRoom,
  Sources,
  LibraryState,
  BasModal,
  BasInputModal,
  BasFavouritesHelper,
  BasMediaStateHelper,
  BasState,
  BasImageUtil
) {
  var favourites = this

  var lastRegisteredSource = null
  var listeners = []
  var ignorePlayResult = false

  /**
   * @type {TBasStateObj}
   */
  var basState = BasState.get()

  /**
   * @type {TCurrentBasCoreState}
   */
  favourites.currentBasCoreState = CurrentBasCore.get()

  favourites.edit = false
  favourites.loadingFavouriteId = null

  favourites.BAS_SOURCES = BAS_SOURCES
  favourites.BAS_SOURCE = BAS_SOURCE

  /**
   * @type {TLibraryState}
   */
  favourites.libraryState = LibraryState.get()

  favourites.selectFilter = selectFilter
  favourites.selectFavourite = selectFavourite
  favourites.addFavourite = addFavourite
  favourites.showCandidates = showCandidates
  favourites.removeFavourite = removeFavourite
  favourites.toggleMode = toggleMode
  favourites.openFavouriteOrderEditor = openFavouriteOrderEditor

  $scope.$on('$destroy', onDestroy)

  init()

  function init () {

    registerSource(favourites.libraryState.current.playerId)

    listeners.push($rootScope.$on(
      BAS_SOURCE.EVT_FAVOURITES_UPDATED,
      _onFavouritesUpdated
    ))
  }

  /**
   * @param {BasFilter} filter
   */
  function selectFilter (filter) {

    var source = LibraryState.getCurrentSource()

    ignorePlayResult = true

    if (source && source.favourites) {

      source.favourites.setFilter(filter)
    }
  }

  /**
   * @param {string} uuid
   */
  function selectFavourite (uuid) {

    var source, music, compatibleSources

    source = LibraryState.getCurrentSource()

    ignorePlayResult = false

    if (source && source.favourites) {

      favourites.loadingFavouriteId = uuid

      if (basState.current.MUSIC) {

        music = CurrentRoom.getRoomMusic()

        if (
          music &&
          [
            BAS_ROOM.MUSIC_T_SONOS,
            BAS_ROOM.MUSIC_T_BOSPEAKER
          ].includes(music.type) &&
          music.basSource
        ) {

          compatibleSources = music.getCompatibleSources()

          if (compatibleSources.indexOf(music.basSource.getId()) === -1) {

            // Sonos room is not listening to any of its compatible sources,
            //  e.g. listening to an HDMI source via Sonos Beam. We must first
            //  set its source to the library's current source (Which is the
            //  Sonos default source) before playing a favourite.
            music.setSource(source.getId()).catch(_ignore)
          }
        }
      } else {

        // App should not set the source before triggering a favourite in video
        //  context (TRIAGE-156)
      }

      source.favourites.play(uuid, true).then(onPlay, onPlayError)
    }

    function onPlay () {

      var _state = BasMediaStateHelper.getHelper()

      favourites.loadingFavouriteId = null

      if (!ignorePlayResult) {

        CurrentRoom.go(_state.get(MEDIA_STATES.PLAYER))

      } else {

        $scope.$applyAsync()
      }
    }

    function onPlayError (err) {

      if (err !== BAS_ERRORS.T_ABORT) {

        favourites.loadingFavouriteId = null
        $scope.$applyAsync()
      }
    }

    function _ignore () {

      // Do nothing
    }
  }

  /**
   * @param {string} uuid
   */
  function removeFavourite (uuid) {

    var source = LibraryState.getCurrentSource()

    if (source && source.favourites) {

      source.favourites.remove(uuid)
        .catch(onRemoveError)
    }

    function onRemoveError () {
      BasModal.show(BAS_MODAL.T_ERROR)
    }
  }

  function addFavourite () {

    var source = LibraryState.getCurrentSource()

    BasInputModal.show(BAS_INPUT_MODAL.T_FAVOURITE_CHANNEL).then(_onModal)

    function _onModal (modal) {

      modal.close.then(_onModalClose)
    }

    function _onModalClose (_result) {

      if (source && source.favourites && Array.isArray(_result)) {

        source.favourites.add(
          BAS_FAVOURITE.T_VIDEO,
          parseInt(_result[1]),
          _result[0]
        ).catch(onFavouriteAddError)
      }
    }
  }

  function showCandidates () {

    const source = LibraryState.getCurrentSource()

    source.favourites.listCandidates(0, 100).then((result) => {

      const currFavourites = source?.favourites.favourites

      const formattedResult = result
        .filter((c) => !currFavourites?.[c.uri])
        .map((c) => {
          let icon
          if (c.images) {
            icon = BasImageUtil.getSizedImage(
              c.images,
              'img',
              120
            )
          }
          if (!icon) icon = BasFavouritesHelper.getFavouriteIconImage(c.uri)
          return (
            {
              text: c.name,
              value: c.uri,
              iconImg: icon
            }
          )
        })

      if (formattedResult.length === 0) {

        return BasModal.show(BAS_MODAL.T_NO_MORE_FAVOURITES)
      }

      BasInputModal.show(BAS_INPUT_MODAL.T_MULTI_SCREEN, {
        title: 'favourites',
        inputs: [
          {
            type: BAS_INPUT_MODAL.T_SELECT,
            options: formattedResult,
            multiple: true,
            initialValue: []
          }
        ],
        autoAdvance: true,
        allowDismiss: true,
        autoSave: false,
        validCheck: BasUtil.isNEArray,
        saveTextId: 'add'
      }).then(_onModal)

      function _onModal (modal) {

        modal.close.then(_onModalClose)
      }

      function _onModalClose (modalResult) {

        if (!modalResult) return

        for (const selectedFavourite of modalResult[0]) {

          if (source?.favourites) {

            const candidate = formattedResult.find((favourite) => (
              favourite.value === selectedFavourite
            ))

            source.favourites.add(
              BAS_FAVOURITE.T_VIDEO,
              candidate.value,
              candidate.text
            ).catch(onFavouriteAddError)
          }
        }
      }
    }).catch(onFavouriteAddError)
  }

  function onFavouriteAddError () {
    BasModal.show(BAS_MODAL.T_ERROR)
  }

  /**
   * @param {boolean} [force]
   */
  function toggleMode (force) {

    ignorePlayResult = true

    favourites.edit = typeof force === 'boolean'
      ? force
      : !favourites.edit
  }

  /**
   * @param {(string|number)} sourceId
   */
  function registerSource (sourceId) {

    if (BasUtil.isNEString(sourceId) ||
      BasUtil.isPNumber(sourceId, false)) {

      Sources.registerFor(
        BAS_SOURCE.COL_EVT_FAVOURITES,
        sourceId
      )

      lastRegisteredSource = sourceId
    }
  }

  function openFavouriteOrderEditor () {

    ModalService.showModal({
      controller: 'favouritesPickerModalCtrl',
      controllerAs: 'modal',
      template: BAS_HTML.favouritesPickerModal
    })
  }

  function unregisterSource () {

    if (BasUtil.isNEString(lastRegisteredSource) ||
      BasUtil.isPNumber(lastRegisteredSource, false)) {

      Sources.unregisterFor(
        BAS_SOURCE.COL_EVT_FAVOURITES,
        lastRegisteredSource
      )
    }
  }

  function _onFavouritesUpdated () {

    $scope.$applyAsync()
  }

  function onDestroy () {

    unregisterSource()
    BasUtil.executeArray(listeners)
    listeners = []
  }
}
